import { createSlice } from "@reduxjs/toolkit";
import { fetchWebhookLogs } from "./webhook-logs.thunk";
import { IWebhookLog } from "@grudder/types/integration.types";


const initialState: {
    data: {
        data: IWebhookLog[];
        total: number;
    };
    loading: boolean;
    error: string | null;
} = {
    data: {
        data: [],
        total: 0
    },
    loading: false,
    error: null,
};

const webhookLogSlice = createSlice({
    name: "webhookLogs",
    initialState,
    reducers: {
        setWebhookLogs: (state, action) => {
            state.data = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchWebhookLogs.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchWebhookLogs.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchWebhookLogs.rejected, (state, action) => {
                state.loading = false;
                if (action.error.message) {
                    state.error = (action.error.message as string) || "Failed to fetch webhook logs";
                }
            });
    }
});

export const { setWebhookLogs } = webhookLogSlice.actions;
export default webhookLogSlice.reducer;